import HttpClient from '../../HttpClient/NewApi';

export default {
    create(createCardRequest) {

        return HttpClient.post(`/api/v1/cards`, {
            client: createCardRequest
        });
    }
}

export class CreateCardRequest
{
    constructor(
        name,
        type,
        email,
        address,
        lat,
        lng,
        geoId,
        shouldCallAt,
        callTheme,
        additionalCallInfo,
        sowingArea,
        hasContract,
        worksWithNds,
        contacts,
        websites,
        filials,
        cultures,
        categories,
    ) {
        this.type = type;
        this.name = name;
        this.email = email;
        this.area_full = sowingArea
        this.lat = lat;
        this.lon = lng;
        this.address = address;
        this.geo_id = geoId;
        this.date_will_call = shouldCallAt;
        this.call_aim = callTheme;
        this.additional_info = additionalCallInfo;
        this.contract = hasContract;
        this.vat = worksWithNds;
        this.contacts = contacts
        this.websites = websites
        this.filials = filials
        this.cultures = cultures
        this.categories = categories
    }
}

export class Contact
{
    constructor(
        name,
        phone,
        email,
        isVisible,
    ) {
        this.name = name;
        this.phone = phone;
        this.email = email;
        this.isVisible = isVisible;
    }
}

export class GrainVolume
{
    constructor(
        grainId,
        price,
        volume,
        comment,
    ) {
        this.culture_id = grainId;
        this.price = price;
        this.volume = volume;
        this.area = 0;
        this.quality_comment = comment;
    }
}



// WEBPACK FOOTER //
// ./apiClient/Card/Create/index.js